import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function LegalNotice() {
  return (
    <LegalLayout title="Aviso Legal" updated="2026" testid="page-aviso-legal">
      <P>En cumplimiento de la Ley 34/2002 de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se facilita la siguiente información del titular del sitio web <b>cyvrlabs.com</b>.</P>

      <H2>1. Datos identificativos</H2>
      <UL>
        <li>Titular: CYVRLABS — Ciberseguridad, vulnerabilidades y trabajos de seguridad informática</li>
        <li>NIF: 40967909X</li>
        <li>Domicilio: Apartado de Correos 12345</li>
        <li>Contacto: contacto@cyvrlabs.com</li>
      </UL>

      <H2>2. Objeto</H2>
      <P>El sitio ofrece información y contratación de servicios de ciberseguridad (auditorías, pentesting, SOC, análisis forense y formación).</P>

      <H2>3. Condiciones de uso</H2>
      <P>El usuario se compromete a hacer un uso lícito del sitio y a no emplear las herramientas de análisis sobre sistemas de los que no sea titular o para los que no cuente con autorización expresa. El escaneo no autorizado de sistemas ajenos es ilegal y de exclusiva responsabilidad del usuario.</P>

      <H2>4. Propiedad intelectual e industrial</H2>
      <P>Todos los contenidos (textos, logotipos, diseño y software) son titularidad de CYVR Labs o de sus licenciantes y están protegidos por la normativa de propiedad intelectual e industrial.</P>

      <H2>5. Responsabilidad</H2>
      <P>CYVR Labs no se responsabiliza del uso indebido de los contenidos ni de los daños derivados del mal uso del sitio por parte del usuario.</P>

      <H2>6. Legislación aplicable</H2>
      <P>Estas condiciones se rigen por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales que correspondan conforme a derecho.</P>
    </LegalLayout>
  );
}
